import { render, staticRenderFns } from "./RankWidget.vue?vue&type=template&id=2a98d766&scoped=true&"
import script from "./RankWidget.vue?vue&type=script&lang=js&"
export * from "./RankWidget.vue?vue&type=script&lang=js&"
import style0 from "./RankWidget.vue?vue&type=style&index=0&id=2a98d766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98d766",
  null
  
)

export default component.exports